/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, { useContext, useReducer } from 'react';

const siteRegex = /^[A-Z]{2}\/[a-z]{2}$/g;

const SET_LANGUAGE = 'SET_LANGUAGE';

const SiteStateContext = React.createContext();
const SiteDispatchContext = React.createContext();

const parseWindowLocation = () => {
    let index = window.location.href.indexOf(window.location.pathname);
    const baseUrl = window.location.href.substring(0, index);
    let contextPath = baseUrl;
    let path = window.location.pathname;
    let queryParams = window.location.search;
    let context = path.substring(1, 6);
    let site = null;
    let language = null;
    if (siteRegex.test(context)) {
        path = path.substring(7);
        contextPath = `${baseUrl}/${context}`;
        site = context.substring(0, 2);
        language = context.substring(3);
    } else {
        context = null;
    }
    return [baseUrl, contextPath, context, site, language, path, queryParams];
};

const SiteReducer = (state, action) => {
    switch (action.type) {
        case SET_LANGUAGE: {
            if (state.language !== action.payload) {
                return {...state, language: action.payload};
            }
            return state;
        }
        default: {
            throw new Error(`[SiteReducer] Unsupported action type: ${action.type}.`);
        }
    }
};

export const SiteProvider = ({children}) => {
    const [baseUrl, contextPath, context, site, language, path, queryParams] = parseWindowLocation();
    const [state, dispatch] = useReducer(SiteReducer, {baseUrl, contextPath, context, site, language, path, queryParams});
    return (
        <SiteStateContext.Provider value={state}> 
            <SiteDispatchContext.Provider value={dispatch}>
                {children}
            </SiteDispatchContext.Provider>
        </SiteStateContext.Provider>
    );

};

export const useSiteState = () => {
    const context = useContext(SiteStateContext);
    if (!context) {
        throw new Error('useSiteState must be used within a SiteProvider');
    }
    return context;
};

export const useSiteMutator = () => {
    const dispatch = useContext(SiteDispatchContext);
    if (!dispatch) {
        throw new Error('useSiteMutator must be used within a SiteProvider');
    }
    const setLanguage = (language) => {
        dispatch({type: SET_LANGUAGE, payload: language});
    };
    return {setLanguage};
};
